<template>
  <header
    v-cloak
    ref="siteHeader"
    class="site-header"
    :class="[
      $store.state.nav.subNavIsOpen ? 'subnav-is-open' : '',
      beforeMount ? 'before-mounted' : '',
    ]"
    data-hook="header"
  >
    <DesktopNav />
    <MobileNav />
  </header>
</template>

<script>
import recommendationStore from '@/stores/recommendation'
import { registerStores } from '@/helpers/stores'
import { KEY_ESC } from '@/helpers/keyCodes'
import settings from './navigation-settings'
import DesktopNav from './DesktopNav/DesktopNav.vue'
import MobileNav from './MobileNav/MobileNav.vue'

export default {
  name: 'Navigation',

  components: {
    DesktopNav,
    MobileNav,
  },

  data() {
    return {
      beforeMount: true,
    }
  },

  beforeCreate() {
    registerStores({ recommendation: recommendationStore })
  },

  created() {
    this.manageNavState()

    window.addEventListener('resize', () => {
      this.$store.dispatch('nav/toggleSubnav', false)
      this.manageNavState()
    })
  },

  mounted() {
    const self = this
    // Wait for initial line hover animation to finish until making line color non-transparent
    setTimeout(() => {
      this.beforeMount = false
    }, settings.transitionTime)

    const navdata = JSON.parse(document.querySelector('#navData').innerHTML)

    // Update state with asynchronous data
    Object.keys(navdata.desktop).forEach(element => {
      self.$store.dispatch('nav/updateState', {
        key: element,
        value: navdata.desktop[element],
      })
    })

    Object.keys(navdata.mobile).forEach(element => {
      self.$store.dispatch('nav/updateState', {
        key: element,
        value: navdata.mobile[element],
      })
    })

    document.addEventListener('keydown', this.handleKeydown)
    window.dispatchEvent(new CustomEvent('on:navigation-ready'))
  },

  beforeDestroy() {
    document.removeEventListener('keydown', this.handleKeydown)
  },

  methods: {
    manageNavState() {
      // This handling is needed to ensure that we don't try to loop over non existing values on desktop
      const desktopIsActive = window.innerWidth >= settings.mobileBreakpoint
      const currentTopic = desktopIsActive ? 0 : -1
      const currentBlock = desktopIsActive ? 0 : -1
      this.$store.commit('nav/setCurrentTopic', currentTopic)
      this.$store.commit('nav/setCurrentBlock', currentBlock)

      return (this.$store.state.nav.desktopNavigation = desktopIsActive)
    },
    handleKeydown(e) {
      if (e.keyCode === KEY_ESC) {
        this.$store.dispatch('nav/setAdditionalNav', '')
        this.$store.dispatch('nav/toggleSubnav', false)
      }
    },
  },
}
On.initSmoothScroller()
</script>
